import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { SbSupportTextBlockComponent } from '@app/+modals/sb-support/blocks/text/sb-support-text-block.component';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { getAccount } from '@reducers/account/account-service.selectors';
import { AccountService } from '@reducers/account/account.service';
import { AppState } from '@reducers/interfaces';
import { SwitchComponent } from '@sb/ui/switch';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'sb-support-access-widget',
  templateUrl: './sb-support-access-widget.component.html',
  imports: [SwitchComponent, SbSupportTextBlockComponent, ReactiveFormsModule, TranslatePipe],
})
export class SbSupportAccessWidgetComponent implements OnInit {
  #accountService = inject(AccountService);
  #store = inject<Store<AppState>>(Store);
  #destroyRef = inject(DestroyRef);

  serviceDeskAccessCtrl = new UntypedFormControl(false);

  ngOnInit() {
    this.#store
      .select(getAccount)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((account) => {
        this.serviceDeskAccessCtrl.patchValue(account.servicedesk_access_enabled, { onlySelf: true, emitEvent: false });
      });

    this.serviceDeskAccessCtrl.valueChanges
      .pipe(
        switchMap((servicedesk_access_enabled) =>
          this.#accountService.toggleSupportAccess({ Account: { servicedesk_access_enabled } }),
        ),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }
}
